// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { VerticalDetailsRowItem } from '@shared/commons/cache/VerticalPanel/VerticalDetailsRowItem';
import { VerticalDetailsTypePointer } from '@shared/commons/cache/VerticalPanel/VerticalDetailsTypePointer';
export class VerticalDetailsGroupProps {
}
export class VerticalDetailsGroupComponentView {
    constructor() {
        this.rowItems = [];
    }
}
export class VerticalDetailsGroupViewModel extends AbstractViewModel {
    get groupName() {
        return this.componentView.groupName;
    }
    set groupName(value) {
        this.updateComponentView('groupName', value);
    }
    get isOpen() {
        return this.componentView.isOpen;
    }
    set isOpen(value) {
        this.updateComponentView('isOpen', value);
    }
    get rowItems() {
        return this.componentView.rowItems;
    }
    set rowItems(value) {
        this.updateComponentView('rowItems', value);
    }
    get visibleGroup() {
        return this.componentView.visibleGroup;
    }
    set visibleGroup(value) {
        this.updateComponentView('visibleGroup', value);
    }
    constructor() {
        super(VerticalDetailsGroupComponentView);
        this.group = null;
        this.onUpdate = () => {
            if (isNullOrUndefined(this.rowItems) || this.rowItems.length === 0) {
                return;
            }
            for (const row of this.rowItems) {
                row.onUpDateEmit();
            }
        };
    }
    initialize(props) {
        super.initialize(props);
        this.props = props;
        this.createGroupController(props.groupItem);
    }
    update(props) {
        super.update(props);
        if (this.props.groupItem !== props.groupItem) {
            this.createGroupController(props.groupItem);
        }
        this.props = props;
    }
    dispose() {
        this.group.unsubscribeOnUpDateEmit(this.onUpdate);
        super.dispose();
    }
    changeStateCollapse() {
        const isOpen = this.isOpen;
        const type = this.group.getType();
        this.isOpen = !isOpen;
        this.group.onChangeOpenedStateEmit(type, !isOpen);
    }
    createGroupController(value) {
        if (isNullOrUndefined(value)) {
            return;
        }
        this.group = value;
        this.group.subscribeOnUpDateEmit(this.onUpdate);
        this.groupName = this.group.getGroupName();
        this.isOpen = this.group.getOpenedState();
        this.createRowItem();
    }
    createRowItem() {
        const controller = this.group.getController();
        const groupType = this.group.getType();
        const groupItemsTypes = controller.getGroupItemsTypes();
        this.rowItems = [];
        for (const itemType of groupItemsTypes) {
            if (controller.isHiddenItemRow(itemType)) {
                continue;
            }
            const typePointer = new VerticalDetailsTypePointer(itemType, groupType);
            const rowItem = new VerticalDetailsRowItem(typePointer, controller);
            if (!rowItem.getItemValue().isValid()) {
                continue;
            }
            this.rowItems.push(rowItem);
        }
        const dynamicRowItems = controller.getDynamicItems();
        for (let i = 0; i < dynamicRowItems.length; i++) {
            const dynamicItem = dynamicRowItems[i];
            if (controller.isHiddenItemRow(dynamicItem.type)) {
                continue;
            }
            const typePointer = new VerticalDetailsTypePointer(dynamicItem.type, groupType, dynamicItem.key);
            const rowItem = new VerticalDetailsRowItem(typePointer, controller);
            if (!rowItem.getItemValue().isValid()) {
                continue;
            }
            this.rowItems.push(rowItem);
        }
        if (this.rowItems.length === 0) {
            this.visibleGroup = false;
            return;
        }
        this.visibleGroup = true;
    }
}
